const OWN_DOMAINS = [
  'vialaser.com.br',
  'vialaserdepilacion.com.py',
  'vialaser.uy',
  'vialaser.cr',
];

function isOwnDomain(hostname: string) {
  return OWN_DOMAINS.some(
    domain => hostname === domain || hostname.endsWith(`.${domain}`),
  );
}

export default function getReferrerHostname(referrer: string) {
  if (!referrer) return undefined;

  try {
    const { hostname } = new URL(referrer);

    if (!hostname || isOwnDomain(hostname)) return undefined;

    return hostname;
  } catch (error) {
    return undefined;
  }
}
